import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
    selector: 'display-success-import',
    templateUrl: './display-success-import.component.html',
    styleUrls: ['./display-success-import.component.css']
})

export class DisplaySuccessImportComponent implements OnInit {
  private importResultSheetTable: object[] = [];
  private dataTable: any;
  private dtTable: any;
  private dtOptions: any;
  private tableHeader: string[] = [];

  constructor() { }

  ngOnInit() {
    this.dataTable = $('#importFilesResults');
  }

  public show(importResult: object[]) {
    this.importResultSheetTable = importResult;
    this.tableHeader = Object.keys(importResult[0]);

    this.createTable();
  }

  private createTable() {
    if (this.dtTable) {
      this.dtTable.Destroy();
      this.dtTable = null;
    }

    this.dtOptions = {
      data: this.importResultSheetTable,
      columns: this.tableHeader.map(x => ({ name: x })),
      index: false,
      select: false,
      filter: false,
      orderBy: false,
      exportButtons: []
    }

    this.dtTable = this.dataTable.LinkTable(this.dtOptions);
  }
}
